import DatePicker from 'vue2-datepicker'
import DayEndClosureLogs from './DayEndClosureLogs/index.vue'
import ScanTallyLogs from './ScanTallyLogs/index.vue'
import  StickerPrintingLogs from './StickerPrintingLogs/index.vue'

export default {
  name: 'additional-event-logs',
  components: {
		DatePicker,
		'first': StickerPrintingLogs,
		'second': ScanTallyLogs,
		'third': DayEndClosureLogs
	},
	props: [],
	data() {
		return {
			currentTab: 'First',
			componentKey: 0,
			shippingId: null,
			tabs: [{
					key: 'First',
					value: 'Sticker Printing Logs'
				},
				{
					key: 'Second',
					value: 'Scan Tally Logs'
				},
				{
					key: 'Third',
					value: 'Day End Closure Logs'
				}
			],
		}
	},
	computed: {
		// selects all checkbox's option
		currentTabComponent: function() {
			this.componentKey += 1
			return this.currentTab.toLowerCase()
		}
	},
	created() {
		// this.shippingId = this.$route.params.shippingId;
		this.shippingId = this.$route.query.shippingId;
		console.log("ShippingID : ", this.shippingId);
	},
	mounted() {},
	methods: {}
}



// WEBPACK FOOTER //
// ./src/views/components/AdditionalEventLogs/AdditionalEventLogs.js